import React, { useState, useEffect } from 'react';

interface Props {
  onSubmit: (email: string) => void;
  error?: string;
}

export function RegisterPage({ onSubmit, error }: Props) {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');

  useEffect(() => {
    setEmailError('');
  }, []);

  const handleSubmit = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setEmailError('Geçersiz e-posta formatı');
      return;
    }
    setEmailError('');
    onSubmit(email);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  return (
    <div className="container neomorphic register-page">
      {/* <img src="/next.svg" alt="Portal" width="auto" className="logo" /> */}
      <br />
      <input
        className="neomorphic-input"
        type="email"
        placeholder="E-posta adresiniz"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        onKeyDown={handleKeyDown}
      />
      {emailError && <div className="error">{emailError}</div>}
      {error && <div className="error">{error}</div>}
      <button className="neomorphic-button" onClick={handleSubmit}>Giriş</button>
    </div>
  );
}
